import React from 'react';

import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';

import TextField from '@mui/material/TextField';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import PieceGestionSearch from 'components/Shared/PieceGestionSearch';
import LigneGestionQualification from 'components/Shared/LigneGestionQualification';
import DepannageDirectClient from 'components/Shared/DepannageDirectClient';
import DropZone from 'components/Shared/DropZone';
import ColisLogistiquePhoto from 'components/Shared/ColisLogistiquePhoto';
import MessageDialog from 'components/Shared/MessageDialog';

import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';
import { AnomalieType } from 'constants.js';
import { TypeCodes } from 'constants.js';

import { reclamationSoumiseQuantiteRetournable } from 'utils/quantiteRetournableHelper';

const styles = theme => ({
    flexContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1)
    },
    group: {
        margin: theme.spacing(1, 0)
    },
    heightLabel: {
        height: '30px'
    },

    //link: theme.style.link,

    fieldset: {
        flexBasis: '100%',
        marginBottom: '10px',

        marginLeft: '2px',
        marginRight: '2px',
        paddingTop: '0.35em',
        paddingBottom: '0.625em',
        paddingLeft: '0.75em',
        paddingRight: '0.75em',
        border: '1px solid ' + theme.palette.primary.main + ''
    },

    bonRetourImprime: {
        backgroundColor: theme.palette.primary.main
    },
    bonRetourNonImprime: {
        backgroundColor: theme.palette.secondary[500]
    },

    bold: {
        fontWeight: 'bold'
    }
});

/* Liste des réponses possibles */
const etatProduitLabel = "Quel est l'état du produit ? ";
const etatsProduit = [
    "Le produit est neuf, non monté et non utilisé.",
    "Le produit est déja utilisé ou monté."
];


const clientInformeLabel = "Le client a été informé des conditions de reprise";
const priseConnaissanceDemarcheLabel = "J'ai bien pris connaissance de la démarche";

const quantiteRetournableDepasseeLabel = "La quantité déclarée dépasse la quantité retournable. Veuillez la corriger.";

const memoCloture = `Ce dossier après-vente concerne un article déjà utilisé ou déjà monté et non plus un défaut non monté à la première utilisation.
Le service Qualité Entrepôt ne peut pas prendre en charge cette demande.
Il s'agit d'une demande de SAV, merci de contacter le fournisseur ou d'orienter le client vers le magasin le plus proche.`;

const warningNbLignes = `Un seul article est autorisé sur cette qualification.

Pour un autre article défaut produit, merci de procéder à une nouvelle saisie`;

const warningZeroLigne = 'Veuillez sélectionner au moins une ligne article.';

const attacherBonRetourFormat = `Attacher les conditions de reprise défaut produit en pièce jointe au mail de notification client envoyé à : {0}`;


/* Liste des réponses possibles */
const photoConsulteeLabel = "Avez-vous pris connaissance de la photo ? ";
const photoConsulteeLabels = [
    "Oui, j'ai trouvé les informations souhaitées et tout est conforme (dossier après-vente clôturé automatiquement).",
    "Oui, mais je souhaite créer le dossier après-vente"
];

const Etape = {
    ChoixDeLaPiece: 0,
    Qualifications: 1
};

class DefautProduitStep extends React.Component {
    state = {
        expandedPanel: 'panelPiece',
        etape: Etape.ChoixDeLaPiece,
        bonRetourImprime: false,
        alerteRetournableOpen: false
    };

    depasseQuantiteRetournable = () => {
        const { reclamation } = this.props;
        return reclamationSoumiseQuantiteRetournable(reclamation)
            && reclamation.lignes.some(l => l.quantiteRetournable !== undefined && l.quantiteRetournable !== null
                && Number(l.quantiteAnomalie) > l.quantiteRetournable);
    }

    componentDidMount() {
        // On détermine si on doit rendre accessible le bouton pour passer à l'étape suivante ou le bouton de création.
        const { reclamation, onNextStepValid } = this.props;

        const nextStepValid = reclamation.numeroPiece.length > 0 && reclamation.lignes.length > 0;

        onNextStepValid(nextStepValid);
    }

    // Obtention d'un détail quelconque.
    getDetail(code, typeValeur) {
        const { reclamation } = this.props;

        // Initialisation de la valeur
        let valeur = '';

        // Obtention du code
        const detail = reclamation.qualificationDetails.find(detail => detail.code === code);

        // Affectation si possible de la valeur en fonction du type demandé
        if (detail !== undefined) {
            valeur = detail[typeValeur];
        }

        return valeur;
    }

    getPhotoConsultee() {
        return this.getDetail(ReclamationQualificationDetailCodes.PhotoConsultee, 'valeurInteger');
    }

    getDepannageDirectClient() {
        const { reclamation } = this.props;

        let depannageDirectClient = '';

        const detailDepannageDirectClient = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.DepannageDirectClient);
        if (detailDepannageDirectClient !== undefined) {
            depannageDirectClient = detailDepannageDirectClient.valeurBool;
        }

        return depannageDirectClient;
    }

    getEtatProduit() {
        const { reclamation } = this.props;

        let etatProduit = '';

        const detailEtatProduit = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.EtatProduit);
        if (detailEtatProduit !== undefined) {
            etatProduit = detailEtatProduit.valeurInteger;
        }

        return etatProduit;
    }


    getClientInforme() {
        const { reclamation } = this.props;

        let clientInforme = false;

        const detailClientInforme = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.ClientInforme);
        if (detailClientInforme !== undefined) {
            clientInforme = detailClientInforme.valeurBool;
        }

        return clientInforme;
    }

    getPriseConnaissanceDemarche() {
        const { reclamation } = this.props;

        let priseConnaissanceDemarche = false;

        const detailPriseConnaissanceDemarche = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.PriseConnaissanceDemarche);
        if (detailPriseConnaissanceDemarche !== undefined) {
            priseConnaissanceDemarche = detailPriseConnaissanceDemarche.valeurBool;
        }

        return priseConnaissanceDemarche;
    }

    getAfficheDocumentPriseEnCharge() {
        const { reclamation, livraisonDirecte, rapido } = this.props;

        let afficheDocumentPriseEnCharge = false;

        if (reclamation.type.code !== TypeCodes.Cession && reclamation.lignes && reclamation.lignes.length === 1) {
            afficheDocumentPriseEnCharge = reclamation.lignes[0].marqueExclusive && !livraisonDirecte && !rapido;
        }

        return afficheDocumentPriseEnCharge;
    }


    getAfficheMemoCloture() {
        const { reclamation, livraisonDirecte, rapido } = this.props;

        var etatProduit = this.getEtatProduit();

        let afficheMemoCloture = false;

        if (etatProduit === 1 && !livraisonDirecte && !rapido && reclamation.lignes && reclamation.lignes.length === 1) {
            afficheMemoCloture = !reclamation.lignes[0].marqueExclusive && !reclamation.lignes[0].autoriseSAVPlateformeLogistique;

        }

        return afficheMemoCloture;
    }

    getAttacherBonRetour() {
        const { reclamation } = this.props;

        let attacherBonRetour = false;

        const detailAttacherBonRetour = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.AttacherBonRetour);
        if (detailAttacherBonRetour !== undefined) {
            attacherBonRetour = detailAttacherBonRetour.valeurBool;
        }

        return attacherBonRetour;
    }

    checkErrors(depannageDirectClient, etatProduit, priseConnaissanceDemarche, clientInforme, lignes, bonRetourImprime, attacherBonRetour, photoConsultee) {
        const { reclamation, utilisateurMagasin, livraisonDirecte, rapido, colisLogistiques } = this.props;

        let errors = [];

        if (reclamation.numeroPiece.length === 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.Piece, errorMsg: 'Veuillez sélectionner une pièce.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.Piece, errorMsg: null });
        }

        if (lignes.length !== 1) {
            errors.push({ key: ReclamationQualificationDetailCodes.NbLignes + '_DEFAUT_PRODUIT', errorMsg: 'Une ligne doit être renseignée.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.NbLignes + '_DEFAUT_PRODUIT', errorMsg: null });

            // On rajoute '_DEFAUT_PRODUIT' car ReclamationQualificationDetailCodes.NbLignes est supprimé des errors, et ça pose problème dans ce cas.

            if (reclamation.type.code !== TypeCodes.Cession && lignes[0].marqueExclusive && !livraisonDirecte && !rapido) {
                if (clientInforme !== true) {
                    errors.push({ key: ReclamationQualificationDetailCodes.ClientInforme, errorMsg: 'Veuillez confirmer que le client a été informé.' });
                } else {
                    errors.push({ key: ReclamationQualificationDetailCodes.ClientInforme, errorMsg: null });

                    if (reclamation.suiviEmail) {
                        if (!bonRetourImprime && !attacherBonRetour) {
                            errors.push({ key: "BON_RETOUR", errorMsg: "Veuillez imprimer le bon de retour ou demander de l'attacher dans le mail de notification au client" });
                        }
                        else {
                            errors.push({ key: "BON_RETOUR", errorMsg: null });
                        }
                    }
                    else {
                        if (!bonRetourImprime) {
                            errors.push({ key: "BON_RETOUR", errorMsg: 'Veuillez imprimer le bon de retour' });
                        }
                        else {
                            errors.push({ key: "BON_RETOUR", errorMsg: null });
                        }
                    }
                }
            } else {
                errors.push({ key: ReclamationQualificationDetailCodes.ClientInforme, errorMsg: null });
                errors.push({ key: "BON_RETOUR", errorMsg: null });
            }
        }

        if (etatProduit === '') {
            errors.push({ key: ReclamationQualificationDetailCodes.EtatProduit, errorMsg: etatProduitLabel });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.EtatProduit, errorMsg: null });
        }


        //console.log("etatProduit", etatProduit);
        if (etatProduit === 0 && colisLogistiques.length > 0) {

            let reclaCodes = reclamation.lignes.map(x => x.codeArticle);

            let colisLogistiquesPhoto = colisLogistiques.map(x => {

                let codesArticles = x.lignes.map(x => x.codeArticle);
                let c = {
                    photoId: x.photoId,
                    numeroSupport: x.numeroSupport,
                    concerneRecla: reclaCodes.some(r => codesArticles.indexOf(r) >= 0)
                };
                return c;
            });

            let afficherQuestion = colisLogistiquesPhoto.some(x => x.concerneRecla && x.photoId);

            //console.log("reclaCodes", reclaCodes);
            //console.log("colisLogistiquesPhoto", colisLogistiquesPhoto);
            //console.log("afficherQuestion", afficherQuestion);
            //console.log("photoConsultee", photoConsultee);

            if (afficherQuestion) {
                if (photoConsultee === '') {
                    errors.push({ key: ReclamationQualificationDetailCodes.PhotoConsultee, errorMsg: photoConsulteeLabel });
                } else {
                    errors.push({ key: ReclamationQualificationDetailCodes.PhotoConsultee, errorMsg: null });
                }
            } else {
                errors.push({ key: ReclamationQualificationDetailCodes.PhotoConsultee, errorMsg: null });
            }
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.PhotoConsultee, errorMsg: null });
        }


        if (etatProduit === 0
            && reclamationSoumiseQuantiteRetournable(reclamation)
            && lignes.some(l => l.quantiteRetournable !== undefined && l.quantiteRetournable !== null
                && Number(l.quantiteAnomalie) > l.quantiteRetournable)) {
            errors.push({ key: "RETOURNABLE_DEPASSE", errorMsg: quantiteRetournableDepasseeLabel });
        } else {
            errors.push({ key: "RETOURNABLE_DEPASSE", errorMsg: null });
        }

        if (etatProduit === 1) {


            if (!livraisonDirecte
                && !rapido
                && lignes.length === 1
                && !lignes[0].marqueExclusive
                && !lignes[0].autoriseSAVPlateformeLogistique) {

                if (priseConnaissanceDemarche !== true) {
                    errors.push({ key: ReclamationQualificationDetailCodes.PriseConnaissanceDemarche, errorMsg: priseConnaissanceDemarcheLabel });
                } else {
                    errors.push({ key: ReclamationQualificationDetailCodes.PriseConnaissanceDemarche, errorMsg: null });
                }
            }
        }

        if (reclamation.type.code === TypeCodes.Client && utilisateurMagasin) {
            if (depannageDirectClient === '') {
                errors.push({ key: ReclamationQualificationDetailCodes.DepannageDirectClient, errorMsg: 'Avez-vous résolu le problème de votre client ?' });
            } else {
                errors.push({ key: ReclamationQualificationDetailCodes.DepannageDirectClient, errorMsg: null });
            }
        }

        //console.log("errors", errors);
        return errors;
    }

    handleChangePanel = panel => (event, expandedPanel) => {
        this.setState({
            expandedPanel: expandedPanel ? panel : false
        });
    }

    handleChange = (event) => {
        const { onChange, reclamation } = this.props;

        const depannageDirectClient = this.getDepannageDirectClient();
        const etatProduit = this.getEtatProduit();
        const priseConnaissanceDemarche = this.getPriseConnaissanceDemarche();
        const clientInforme = this.getClientInforme();
        const attacherBonRetour = this.getAttacherBonRetour();

        const errors = this.checkErrors(depannageDirectClient, etatProduit, priseConnaissanceDemarche, clientInforme, reclamation.lignes, this.state.bonRetourImprime, attacherBonRetour, this.getPhotoConsultee());

        onChange(event, errors);
    }

    handleSelectPiece = (value) => {
        const { onSelectPiece, reclamation } = this.props;

        // On ouvre le panel avec les lignes de la pièce.
        this.setState({
            expandedPanel: 'panelLignes',
            etape: Etape.Qualifications
        });

        const depannageDirectClient = this.getDepannageDirectClient();
        const etatProduit = this.getEtatProduit();
        const priseConnaissanceDemarche = this.getPriseConnaissanceDemarche();
        const clientInforme = this.getClientInforme();
        const attacherBonRetour = this.getAttacherBonRetour();

        const errors = this.checkErrors(depannageDirectClient, etatProduit, priseConnaissanceDemarche, clientInforme, reclamation.lignes, this.state.bonRetourImprime, attacherBonRetour, this.getPhotoConsultee());

        onSelectPiece(value, errors);
    }

    handleQualificationDetailsDepannageDirectClientChange = (event) => {
        const { onDetailChange, reclamation } = this.props;

        const qualificationDetail = {
            position: 6,
            code: ReclamationQualificationDetailCodes.DepannageDirectClient,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: 'Avez-vous résolu le problème de votre client ?',
            valeurBool: event.target.value
        };

        const depannageDirectClient = event.target.value;
        const etatProduit = this.getEtatProduit();
        const priseConnaissanceDemarche = this.getPriseConnaissanceDemarche();
        const clientInforme = this.getClientInforme();
        const attacherBonRetour = this.getAttacherBonRetour();

        const errors = this.checkErrors(depannageDirectClient, etatProduit, priseConnaissanceDemarche, clientInforme, reclamation.lignes, this.state.bonRetourImprime, attacherBonRetour, this.getPhotoConsultee());

        onDetailChange(qualificationDetail, errors, null);
    }


    handleQualificationDetailsEtatProduitChange = (event) => {
        const { onDetailChange, reclamation } = this.props;

        const qualificationDetail = {
            position: 0,
            code: ReclamationQualificationDetailCodes.EtatProduit,
            type: ReclamationQualificationDetailType.ChoixMultiple,
            libelle: etatProduitLabel,
            valeurString: etatsProduit[event.target.value],
            valeurInteger: parseInt(event.target.value, 10)
        };

        let detailsToDelete = [];
        let errors = [];

        if (event.target.value === '0') {
            detailsToDelete.push(ReclamationQualificationDetailCodes.PriseConnaissanceDemarche);

            errors = this.checkErrors(this.getDepannageDirectClient(), qualificationDetail.valeurInteger, null, this.getClientInforme(), reclamation.lignes, this.state.bonRetourImprime, this.getAttacherBonRetour(), this.getPhotoConsultee());

            if (this.depasseQuantiteRetournable()) {
                this.setState({ alerteRetournableOpen: true });
            }
        }
        else {
            detailsToDelete.push(ReclamationQualificationDetailCodes.PhotoConsultee);

            errors = this.checkErrors(this.getDepannageDirectClient(), qualificationDetail.valeurInteger, this.getPriseConnaissanceDemarche(), this.getClientInforme(), reclamation.lignes, this.state.bonRetourImprime, this.getAttacherBonRetour(), '');
        }

        onDetailChange(qualificationDetail, errors, detailsToDelete);
    }


    handleQualificationDetailsClientInformeChange = (event) => {
        const { onDetailChange, reclamation } = this.props;

        const qualificationDetails = [{
            position: 3,
            code: ReclamationQualificationDetailCodes.ClientInforme,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: clientInformeLabel,
            valeurBool: event.target.checked
        }];

        const depannageDirectClient = this.getDepannageDirectClient();
        const etatProduit = this.getEtatProduit();
        const priseConnaissanceDemarche = this.getPriseConnaissanceDemarche();
        const clientInforme = event.target.checked;
        const attacherBonRetour = this.getAttacherBonRetour();

        const errors = this.checkErrors(depannageDirectClient, etatProduit, priseConnaissanceDemarche, clientInforme, reclamation.lignes, this.state.bonRetourImprime, attacherBonRetour, this.getPhotoConsultee());
        onDetailChange(qualificationDetails, errors, null);
    }

    handleQualificationDetailsPriseConnaissanceDemarcheChange = (event) => {
        const { onDetailChange, reclamation } = this.props;

        let qualificationDetails = [];
        let detailsToDelete = [];

        if (event.target.checked) {
            qualificationDetails.push(
                {
                    position: 4,
                    code: ReclamationQualificationDetailCodes.DemarcheSAV,
                    type: ReclamationQualificationDetailType.Texte,
                    libelle: "Notification de demande de SAV",
                    valeurString: memoCloture
                });
            qualificationDetails.push(
                {
                    position: 5,
                    code: ReclamationQualificationDetailCodes.PriseConnaissanceDemarche,
                    type: ReclamationQualificationDetailType.Booleen,
                    libelle: priseConnaissanceDemarcheLabel,
                    valeurBool: event.target.checked
                });
        }
        else {
            detailsToDelete.push(ReclamationQualificationDetailCodes.PriseConnaissanceDemarche);
            detailsToDelete.push(ReclamationQualificationDetailCodes.DemarcheSAV);
        }

        const depannageDirectClient = this.getDepannageDirectClient();
        const etatProduit = this.getEtatProduit();
        const priseConnaissanceDemarche = event.target.checked;
        const clientInforme = this.getClientInforme();
        const attacherBonRetour = this.getAttacherBonRetour();

        const errors = this.checkErrors(depannageDirectClient, etatProduit, priseConnaissanceDemarche, clientInforme, reclamation.lignes, this.state.bonRetourImprime, attacherBonRetour, this.getPhotoConsultee());

        onDetailChange(qualificationDetails, errors, detailsToDelete);
    }

    handleQualificationDetailsAttacherBonRetour = (event) => {
        const { onDetailChange, reclamation } = this.props;

        const attacherBonRetourLabel = attacherBonRetourFormat.replace("{0}", reclamation.suiviEmail);

        const qualificationDetail = {
            position: 7,
            code: ReclamationQualificationDetailCodes.AttacherBonRetour,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: attacherBonRetourLabel,
            valeurBool: event.target.checked
        };

        const depannageDirectClient = this.getDepannageDirectClient();
        const etatProduit = this.getEtatProduit();
        const priseConnaissanceDemarche = this.getPriseConnaissanceDemarche();
        const clientInforme = this.getClientInforme();

        const errors = this.checkErrors(depannageDirectClient, etatProduit, priseConnaissanceDemarche, clientInforme, reclamation.lignes, this.state.bonRetourImprime, event.target.checked, this.getPhotoConsultee());

        onDetailChange(qualificationDetail, errors, null);
    }




    handleQualificationDetailsPhotoConsulteeChange = (event) => {
        const { onDetailChange, reclamation } = this.props;

        const qualificationDetail = {
            position: 8,
            code: ReclamationQualificationDetailCodes.PhotoConsultee,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: photoConsulteeLabel,
            valeurString: photoConsulteeLabels[event.target.value],
            valeurInteger: parseInt(event.target.value, 10)
        };

        const errors = this.checkErrors(
            this.getDepannageDirectClient(),
            this.getEtatProduit(),
            this.getPriseConnaissanceDemarche(),
            this.getClientInforme(),
            reclamation.lignes,
            this.state.bonRetourImprime,
            this.getAttacherBonRetour(),
            event.target.value);

        onDetailChange(qualificationDetail, errors, null);
    }



    handleAddLigne = (ligne) => {
        const { onAddLigne, reclamation } = this.props;

        const depannageDirectClient = this.getDepannageDirectClient();
        const etatProduit = this.getEtatProduit();
        const priseConnaissanceDemarche = this.getPriseConnaissanceDemarche();
        const clientInforme = this.getClientInforme();
        const attacherBonRetour = this.getAttacherBonRetour();

        // TODO, vérifier s'il n'y pas un souci avec ça car on contre avec les lignes courantes de la récla, et pas avec la nouvelle
        let lignes = [...reclamation.lignes];

        const errors = this.checkErrors(depannageDirectClient, etatProduit, priseConnaissanceDemarche, clientInforme, lignes, this.state.bonRetourImprime, attacherBonRetour, this.getPhotoConsultee());

        onAddLigne(ligne, errors);
    }

    handleRemoveLigne = (numeroLigne) => {
        const { onRemoveLigne, reclamation } = this.props;


        const errors = this.checkErrors(
            this.getDepannageDirectClient(),
            this.getEtatProduit(),
            this.getPriseConnaissanceDemarche(),
            this.getClientInforme(),
            reclamation.lignes.filter(x => x.numeroLigne !== numeroLigne),
            this.state.bonRetourImprime,
            this.getAttacherBonRetour(),
            this.getPhotoConsultee());

        onRemoveLigne(numeroLigne, errors);
    }

    handleClickImprimer = () => {
        const { onDetailChange, reclamation } = this.props;

        window.open('FOUSSIER_conditions_reprise_defaut_produit.pdf');

        const depannageDirectClient = this.getDepannageDirectClient();
        const etatProduit = this.getEtatProduit();
        const priseConnaissanceDemarche = this.getPriseConnaissanceDemarche();
        const clientInforme = this.getClientInforme();
        const attacherBonRetour = this.getAttacherBonRetour();

        const errors = this.checkErrors(depannageDirectClient, etatProduit, priseConnaissanceDemarche, clientInforme, reclamation.lignes, true, attacherBonRetour, this.getPhotoConsultee());

        onDetailChange(null, errors, null);

        this.setState(
            {
                ...this.state,
                bonRetourImprime: true
            });
    };

    renderDepannageDirectClient() {
        const { reclamation, utilisateurMagasin, classes } = this.props;

        const detailDepannageDirectClientValue = this.getDepannageDirectClient();

        if (reclamation.type.code === TypeCodes.Client && utilisateurMagasin) {
            return (<div className={classes.row}>
                <DepannageDirectClient
                    onDetailChange={this.handleQualificationDetailsDepannageDirectClientChange}
                    value={detailDepannageDirectClientValue}
                />
            </div>
            );
        } else {
            return null;
        }
    }


    renderPriseConnaissancePhoto() {
        const { classes, reclamation, colisLogistiques } = this.props;

        const photoConsulteeValue = this.getPhotoConsultee();

        let reclaCodes = reclamation.lignes.map(x => x.codeArticle);



        let colisLogistiquesPhoto = colisLogistiques.map(x => {

            let codesArticles = x.lignes.map(x => x.codeArticle);
            let c = {
                photoId: x.photoId,
                numeroSupport: x.numeroSupport,
                concerneRecla: reclaCodes.some(r => codesArticles.indexOf(r) >= 0)
            };
            return c;
        });

        //console.log("colisLogistiquesPhoto", colisLogistiquesPhoto);

        let afficherQuestion = colisLogistiquesPhoto.some(x => x.concerneRecla && x.photoId);

        return (

            <>

                {afficherQuestion && (
                    <>

                        <div className={classes.row}>

                            <FormControl required className={classes.formControl}>
                                <FormLabel component="legend" sx={{ display: 'flex' }}>
                                    {photoConsulteeLabel}

                                    {colisLogistiquesPhoto.map((colis, index) => {
                                        return (
                                            <ColisLogistiquePhoto
                                                key={index}
                                                colis={colis}
                                                disabledMessage={!colis.photoId ? "pas de photo de ce colis" : !colis.concerneRecla ? "colis non concerné" : ""}
                                                mode={"button"}
                                                size={"large"}
                                            />
                                        );
                                    })}

                                </FormLabel>
                                <RadioGroup
                                    id={ReclamationQualificationDetailCodes.PhotoConsultee}
                                    name={ReclamationQualificationDetailCodes.PhotoConsultee}
                                    className={classes.group}
                                    value={photoConsulteeValue}
                                    onChange={this.handleQualificationDetailsPhotoConsulteeChange}>
                                    {photoConsulteeLabels.map((reponse, index) => (
                                        <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                    ))}
                                </RadioGroup>
                            </FormControl>

                        </div>

                    </>
                )}
            </>


        );

    }


    renderUsageProduit() {
        const { classes, reclamation } = this.props;

        const etatProduitValue = this.getEtatProduit().toString();

        const afficheDocumentPriseEnCharge = this.getAfficheDocumentPriseEnCharge();
        const afficheMemoCloture = this.getAfficheMemoCloture();

        const clientInformeValue = this.getClientInforme();
        const priseConnaissanceDemarcheValue = this.getPriseConnaissanceDemarche();

        const attacherBonRetourValue = this.getAttacherBonRetour();
        const attacherBonRetourLabel = attacherBonRetourFormat.replace("{0}", reclamation.suiviEmail);

        let memoClotureLignes = memoCloture.split("\n");

        return (
            <React.Fragment>

                {reclamation.lignes.length === 0 && (

                    <div className={classes.row}>
                        {warningZeroLigne}
                    </div>

                )}

                {reclamation.lignes.length >= 2 && (

                    <div className={classes.row}>
                        {warningNbLignes}
                    </div>

                )}


                {reclamation.lignes.length === 1 && (

                    <React.Fragment>

                        <div className={classes.row}>
                            <FormControl required className={classes.formControl}>
                                <FormLabel>{etatProduitLabel}</FormLabel>
                                <RadioGroup id={ReclamationQualificationDetailCodes.EtatProduit} name={ReclamationQualificationDetailCodes.EtatProduit} className={classes.group} value={etatProduitValue} onChange={this.handleQualificationDetailsEtatProduitChange}>
                                    {etatsProduit.map((reponse, index) => (
                                        <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </div>


                        {afficheDocumentPriseEnCharge &&
                            (
                                <FormControl component="fieldset" className={classes.fieldset}>
                                    <FormLabel component="legend">Conditions de reprise défaut produit</FormLabel>

                                    <FormControlLabel className={classes.row}
                                        control={
                                            <Checkbox checked={clientInformeValue} onChange={this.handleQualificationDetailsClientInformeChange} value="true" />
                                        }
                                        label={clientInformeLabel}
                                    />



                                    <div className={classes.row}>

                                        <Button onClick={this.handleClickImprimer} className={this.state.bonRetourImprime ? classes.bonRetourImprime : classes.bonRetourNonImprime}>Imprimer les conditions de reprise défaut produit</Button>

                                    </div>


                                    {reclamation.suiviEmail && (

                                        <FormControlLabel className={classes.row}
                                            control={
                                                <Checkbox checked={attacherBonRetourValue} onChange={this.handleQualificationDetailsAttacherBonRetour} value="true" />
                                            }
                                            label={attacherBonRetourLabel}
                                        />

                                    )}


                                </FormControl>

                            )
                        }

                        {afficheMemoCloture &&
                            (
                                <FormControl component="fieldset" className={classes.fieldset}>
                                    <FormLabel component="legend"></FormLabel>
                                    <div className={classes.row}>
                                        {memoClotureLignes.map((x, index) => (<p key={index} className={classes.bold}>{x}</p>))}
                                    </div>
                                    <div className={classes.row}>

                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={priseConnaissanceDemarcheValue} onChange={this.handleQualificationDetailsPriseConnaissanceDemarcheChange} value="true" />
                                            }
                                            label={priseConnaissanceDemarcheLabel}
                                        />

                                    </div>
                                </FormControl>
                            )
                        }

                        {etatProduitValue === '0' && (
                            this.renderPriseConnaissancePhoto()
                        )}

                        {this.renderDepannageDirectClient()}

                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }

    render() {
        const { classes, reclamation, namespace } = this.props;
        const { etape, expandedPanel } = this.state;

        return (
            <React.Fragment>

                <div className={classes.row}>
                    <TextField
                        multiline
                        fullWidth
                        name="commentaire"
                        label="Commentaire"
                        placeholder="Décrire le problème rencontré"
                        maxRows="3"
                        onChange={this.handleChange}
                        value={reclamation.commentaire}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </div>

                <div className={classes.row}>
                    <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
                </div>

                <div className={classes.row}>
                    <Accordion expanded={expandedPanel === 'panelPiece'} onChange={this.handleChangePanel('panelPiece')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={classes.panelSummary}
                        >
                            <Typography >Rechercher une pièce* (obligatoire pour accéder aux lignes)</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <PieceGestionSearch
                                onSelectPiece={this.handleSelectPiece}
                                client={reclamation.client}
                                withLignes
                                namespace={namespace}
                                warningReclamation
                                defautProduitInfos
                                logistiqueInfos={false}
                                defautNumeroPiece={reclamation.numeroPiece}
                            />
                        </AccordionDetails>
                    </Accordion>



                    {reclamation.numeroPiece && etape === Etape.Qualifications && (
                        <>
                            <Accordion sx={{ mt: 2 }} expanded={expandedPanel === 'panelLignes'} onChange={this.handleChangePanel('panelLignes')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    className={classes.panelSummary}
                                >
                                    <Typography >Sélectionner la ligne de commande qui pose problème</Typography>
                                </AccordionSummary>
                                <AccordionDetails className={classes.flexContainer}>
                                    <div className={classes.row}>
                                        <LigneGestionQualification
                                            reclamation={reclamation}
                                            onAddLigne={this.handleAddLigne}
                                            onRemoveLigne={this.handleRemoveLigne}
                                            typeAnomalie={AnomalieType.DefautProduitPremiereUtilisation}
                                            afficherQuantiteRetournable
                                            capperSaisie={false}
                                        />
                                    </div>

                                    {this.renderUsageProduit()}

                                </AccordionDetails>
                            </Accordion>
                        </>
                    )}


                </div>

                <MessageDialog
                    titre="Attention"
                    contenu={quantiteRetournableDepasseeLabel}
                    ouvert={this.state.alerteRetournableOpen}
                    init={this.state.alerteRetournableOpen}
                    texteOK="Ok"
                    onOK={() => this.setState({ alerteRetournableOpen: false })}
                />
            </React.Fragment>
        );
    }
}

DefautProduitStep.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onDetailChange: PropTypes.func.isRequired,
    onSelectPiece: PropTypes.func.isRequired,
    onAddLigne: PropTypes.func.isRequired,
    onRemoveLigne: PropTypes.func.isRequired,
    validationErrors: PropTypes.array.isRequired,
    onNextStepValid: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired,
    rapido: PropTypes.bool.isRequired,
    livraisonDirecte: PropTypes.bool.isRequired
};

export default withStyles(styles)(DefautProduitStep);